import { Col, Form, Row } from "antd"

import InputNumber from "../../../../components/Input/InputNumber.tsx"

export function BudgetSummarySection() {
  const form = Form.useFormInstance()

  const salesPrice = Form.useWatch("sales_price", form)
  const plannedPayable = Form.useWatch("planned_payable", form)

  const margin = (salesPrice ?? 0) - (plannedPayable ?? 0)
  const hasNegativeMargin =
    salesPrice != null && plannedPayable != null && margin < 0

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item label="Estimate Amount" name="estimate_amount">
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              precision={2}
              maxIntegerDigits={10}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item label="Sales Price" name="sales_price">
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              precision={2}
              maxIntegerDigits={10}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item
            label="Planned Payable"
            name="planned_payable"
            validateStatus={hasNegativeMargin ? "warning" : undefined}
            help={
              hasNegativeMargin
                ? "Planned Payable exceeds Sales Price"
                : undefined
            }
          >
            <InputNumber
              prefix="$"
              min={0}
              placeholder="0.00"
              step={0.01}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item label="Margin (Auto)">
            <InputNumber
              prefix="$"
              placeholder="0.00"
              value={margin}
              disabled
              status={hasNegativeMargin ? "warning" : undefined}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
